export const SHARED_SOLUTION_SESSION_PATH = /^\/shared\/[^/]+\/solution-session\//;
export const SHARED_OFFICE_HOURS_SESSION_PATH = /^\/shared\/[^/]+\/office-hours\//;
